import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia component="img" image={product.image} />
      <CardContent className="card-content">
        <Typography>
          {product.name}
        </Typography>
        <Typography variant="h5" style={{ marginTop: '0.5rem', marginBottom: '0.5rem'}}> &#36;{product.cost}</Typography>
        <Rating
        style={{marginBottom: '1rem'}}
          name="read-only"
          value={product.rating}
          precision={0.5}
          readOnly
        />
        <CardActions className="card-actions">
          <Button
            className="card-button"
            variant="contained"
            onClick={handleAddToCart}
          >
            <AddShoppingCartOutlined /> &nbsp; ADD TO CART
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
